import React, { VFC } from 'react';
import T from 'i18n-react';
import Link from '@material-ui/core/Link';
import { KYOTANGO_PCR_NEWS_URL } from '../../constants';

interface Props {
  isBusinessKyotango: boolean;
}
const Description: VFC<Props> = ({ isBusinessKyotango }: Props) => {
  return (
    <>
      {isBusinessKyotango
        ? T.translate('plan.pcr.descriptionKyotango', {
            link: (
              <Link
                href={KYOTANGO_PCR_NEWS_URL}
                target="_blank"
                underline="always"
                rel="noreferrer"
              >
                {T.translate('plan.pcr.linkText')}
              </Link>
            ),
          })
        : T.translate('plan.pcr.description')}{' '}
    </>
  );
};

export default Description;
